import { AuthTokens, camelcaseKeys } from '@uplift/types';
import { Environment } from '../root/root';

class PromiseCache {
  private _cache: Record<string, Promise<unknown>> = {};

  public cached<T extends Promise<unknown>>(name: string, data: unknown, getPromise: () => T): T {
    const key = `${name}-${JSON.stringify(data)}`;

    if (!this._cache[key]) {
      this._cache[key] = getPromise().finally(() => {
        delete this._cache[key];
      });
    }

    return this._cache[key] as T;
  }
}


export const authRequestsCache = new PromiseCache();


export type AuthRefreshTokenOutput = {
  accessToken: string;
  refreshToken: string;
} | {
  error: string;
};


export class AuthClient {
  apiEndpoint = '';

  constructor(environment: Environment) {
    this.apiEndpoint = environment.restApi;
  }

  private async _authRefresh(refreshToken: string): Promise<AuthTokens> {
    const response = await fetch(`${this.apiEndpoint}/auth/refresh`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        refresh_token: refreshToken,
      }),
    });

    const data = camelcaseKeys<AuthRefreshTokenOutput>(await response.json());

    if ('error' in data) {
      throw new Error(data.error);
    }

    return data;
  }


  async authRefreshToken(refreshToken: string): Promise<AuthTokens> {
    return authRequestsCache.cached(
      'auth/refresh',
      { refreshToken },
      () => this._authRefresh(refreshToken),
    );
  }
}
